export default "__VITE_ASSET__B_P$5SRW__"